import { Injectable } from '@angular/core';
import { portalConst } from '@app/config';
import { Product } from '../models/product.model';
import { ApiService } from './api.service';
import { CrudService } from './crud.service';

@Injectable({
  providedIn: 'root',
})
export class ProductsService extends CrudService<Product> {
  constructor(api: ApiService) {
    super(api, `${portalConst.api.vouchers}`);
  }

  public products(publishing_id: number) {
    return this.api.get(`${this.url}v1/product`, { publishing_id });
  }
}
